import { createApp } from "vue";
import { store } from './store/store';
import CountryRegionTrails from "./CountryRegionTrails.vue";
import { i18n } from '../../i18n';


if (document.querySelector('#country_and_region_trails')) {

  const app = createApp(CountryRegionTrails)
  app.use(store)
  app.use(i18n);
  app.mount("#country_and_region_trails")
}
